import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiInstagram } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="site-footer__newsletter"
        aria-labelledby="newsletter-title"
      >
        <div>
          <p className="eyebrow">Private correspondence</p>
          <h2 id="newsletter-title">
            Be first to know about restocks and new assemblages.
          </h2>
        </div>
        <form onSubmit={handleSubscribe}>
          <label htmlFor="footer-email">Email address</label>
          <div>
            <input
              id="footer-email"
              type="email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setSubscribed(false);
              }}
              placeholder="EMAIL"
              required
            />
            <button type="submit" aria-label="Subscribe">
              <FiArrowUpRight aria-hidden="true" />
            </button>
          </div>
          {subscribed && (
            <p role="status">Thank you. You are now on the list.</p>
          )}
        </form>
      </section>

      <div className="site-footer__grid">
        <div className="site-footer__identity">
          <Link to="/" className="site-footer__wordmark">
            {siteConfig.brandName}
          </Link>
          <p>{siteConfig.description}</p>
          <a
            className="site-footer__social"
            href="https://www.instagram.com/"
            target="_blank"
            rel="noreferrer"
          >
            <FiInstagram aria-hidden="true" /> Instagram
          </a>
        </div>

        <nav aria-label="Quick links">
          <h3>Quick links</h3>
          <Link to="/shop">Shop all</Link>
          <Link to="/about">The atelier</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/#journal">Journal</Link>
        </nav>

        <nav aria-label="The atelier">
          <h3>The atelier</h3>
          <Link to="/about">Our story</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Legal terms</Link>
          <Link to="/contact">Customer care</Link>
        </nav>

        <nav aria-label="Online services">
          <h3>Online services</h3>
          <Link to="/shipping">Shipping</Link>
          <Link to="/returns">Returns</Link>
        </nav>
      </div>

      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <span>Germany · EUR €</span>
        <span>Secure payment: Card · PayPal · Klarna</span>
      </div>
    </footer>
  );
}

export default Footer;
